/* eslint-env browser, jquery */
import React from 'react';
import { Slider, StepsList } from './';

const stepsData = [
  'Create your free developer account',
  'Choose identity providers',
  'Choose an SDK or call our API',
  'Hook it up to your app or API'
];

class FlowModule extends React.Component {
  state = {
    step: 1
  };

  componentDidMount() {
    this.startAnimation();
  }

  componentWillUnmount() {
    clearTimeout(this.loadInterval);
    this.loadInterval = true;
  }

  setStep = (stepIndex, delay) => {
    const $ = window.$;
    this.loadInterval = setTimeout(() => {
      if (this.state.step >= 1) {
        this.setState({ step: stepIndex });
        if (stepIndex > 1) {
          $(`li[data-item='item-${stepIndex - 1}']`).removeClass('next');
        } else {
          this.initElement();
        }
      }
    }, delay);
  };

  initElement = () =>
    new Promise(resolve => {
      const $ = window.$;
      const numElements = $('li[data-item]').length;
      for (let x = 2; x <= numElements; x += 1) {
        $(`li[data-item='item-${x}']`).addClass('next');
      }
      resolve();
    });

  startAnimation = () => {
    const $ = window.$;
    const that = this;
    window.addEventListener('scroll', () => {
      const onboardingFlowOffset = $('.onboarding-flow').offset().top;
      const onboardingFlowHeight = $('.onboarding-flow').outerHeight(true);

      if (
        $(window).scrollTop() >= onboardingFlowOffset - 400 &&
        $(window).scrollTop() <= onboardingFlowOffset + onboardingFlowHeight
      ) {
        if (!that.state.step) {
          that.initElement().then(() => {
            that.setState({ step: 1 });
          });
        }
      } else if (that.state.step >= 1) {
        that.setState({ step: 0 });
      }
    });
  };

  render() {
    return (
      <div id="onboarding-carousel" className={`row carousel onboarding-carousel fadeIn`}>
        <div className="col-xs-12 col-md-6">
          <StepsList currentStep={this.state.step} steps={stepsData} />
        </div>
        <div className="col-xs-12 col-md-6">
          <Slider {...this.state} setStep={this.setStep} />
        </div>
      </div>
    );
  }
}

export default FlowModule;



// WEBPACK FOOTER //
// ./src/components/OnboardingFlow/components/FlowModule.js